<template>
  <div style="min-height: 4px; z-index: 100;">
    <v-progress-linear
      v-model="value"
      :active="show"
      query
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  name: 'ProgressBarComponent',

  data () {
    return {
      interval: 0,
      query: true,
      show: true,
      unsubscribe: () => {},
      value: 0,
    }
  },

  computed: {
    ...mapGetters('router_progress', [
      'isLoading',
    ]),
  },

  mounted () {
    this.queryAndIndeterminate()
    setTimeout(() => this.complete(), 5000)
    this.unsubscribe = store.subscribeAction(action => {
      if (action.type === 'router_progress/startLoading') this.queryAndIndeterminate()
      if (action.type === 'router_progress/stopLoading') this.complete()
    })
  },

  beforeDestroy () {
    clearInterval(this.interval)
    this.unsubscribe()
  },

  methods: {
    complete () {
      this.value = 100
      clearInterval(this.interval)
      setTimeout(() => { this.show = false }, 500)
    },

    queryAndIndeterminate () {
      this.show = true
      this.value = 0

      this.interval = setInterval(() => {
        this.value += (95 - this.value) / 4
      }, 1000)
    },
  },
}
</script>
